/* GENERATED by tools/generators/countries.py — DO NOT EDIT.
 * The same 181 countries as `eleat_countries.js`, as an ES module,
 * because React imports and cannot read a window global.
 * Each row: [name, ISO code, dialling code, 中文 name (optional)]. */
export const COUNTRIES = [
  [
    "Afghanistan",
    "AF",
    "93"
  ],
  [
    "Albania",
    "AL",
    "355"
  ],
  [
    "Algeria",
    "DZ",
    "213"
  ],
  [
    "Andorra",
    "AD",
    "376"
  ],
  [
    "Angola",
    "AO",
    "244"
  ],
  [
    "Argentina",
    "AR",
    "54"
  ],
  [
    "Armenia",
    "AM",
    "374"
  ],
  [
    "Aruba",
    "AW",
    "297"
  ],
  [
    "Australia",
    "AU",
    "61",
    "澳洲"
  ],
  [
    "Austria",
    "AT",
    "43"
  ],
  [
    "Azerbaijan",
    "AZ",
    "994"
  ],
  [
    "Bahamas",
    "BS",
    "1242"
  ],
  [
    "Bahrain",
    "BH",
    "973"
  ],
  [
    "Bangladesh",
    "BD",
    "880",
    "孟加拉"
  ],
  [
    "Barbados",
    "BB",
    "1246"
  ],
  [
    "Belarus",
    "BY",
    "375"
  ],
  [
    "Belgium",
    "BE",
    "32"
  ],
  [
    "Belize",
    "BZ",
    "501"
  ],
  [
    "Benin",
    "BJ",
    "229"
  ],
  [
    "Bermuda",
    "BM",
    "1441"
  ],
  [
    "Bhutan",
    "BT",
    "975"
  ],
  [
    "Bolivia",
    "BO",
    "591"
  ],
  [
    "Bosnia and Herzegovina",
    "BA",
    "387"
  ],
  [
    "Botswana",
    "BW",
    "267"
  ],
  [
    "Brazil",
    "BR",
    "55"
  ],
  [
    "Brunei",
    "BN",
    "673"
  ],
  [
    "Bulgaria",
    "BG",
    "359"
  ],
  [
    "Burkina Faso",
    "BF",
    "226"
  ],
  [
    "Burundi",
    "BI",
    "257"
  ],
  [
    "Cambodia",
    "KH",
    "855"
  ],
  [
    "Cameroon",
    "CM",
    "237"
  ],
  [
    "Canada",
    "CA",
    "1",
    "加拿大"
  ],
  [
    "Cape Verde",
    "CV",
    "238"
  ],
  [
    "Cayman Islands",
    "KY",
    "1345"
  ],
  [
    "Chad",
    "TD",
    "235"
  ],
  [
    "Chile",
    "CL",
    "56"
  ],
  [
    "China",
    "CN",
    "86",
    "中國"
  ],
  [
    "Colombia",
    "CO",
    "57"
  ],
  [
    "Congo",
    "CG",
    "242"
  ],
  [
    "Congo (DRC)",
    "CD",
    "243"
  ],
  [
    "Costa Rica",
    "CR",
    "506"
  ],
  [
    "Croatia",
    "HR",
    "385"
  ],
  [
    "Cuba",
    "CU",
    "53"
  ],
  [
    "Cyprus",
    "CY",
    "357"
  ],
  [
    "Czechia",
    "CZ",
    "420"
  ],
  [
    "Denmark",
    "DK",
    "45"
  ],
  [
    "Djibouti",
    "DJ",
    "253"
  ],
  [
    "Dominican Republic",
    "DO",
    "1809"
  ],
  [
    "Ecuador",
    "EC",
    "593"
  ],
  [
    "Egypt",
    "EG",
    "20"
  ],
  [
    "El Salvador",
    "SV",
    "503"
  ],
  [
    "Estonia",
    "EE",
    "372"
  ],
  [
    "Eswatini",
    "SZ",
    "268"
  ],
  [
    "Ethiopia",
    "ET",
    "251"
  ],
  [
    "Fiji",
    "FJ",
    "679"
  ],
  [
    "Finland",
    "FI",
    "358"
  ],
  [
    "France",
    "FR",
    "33",
    "法國"
  ],
  [
    "Gabon",
    "GA",
    "241"
  ],
  [
    "Gambia",
    "GM",
    "220"
  ],
  [
    "Georgia",
    "GE",
    "995"
  ],
  [
    "Germany",
    "DE",
    "49",
    "德國"
  ],
  [
    "Ghana",
    "GH",
    "233"
  ],
  [
    "Gibraltar",
    "GI",
    "350"
  ],
  [
    "Greece",
    "GR",
    "30"
  ],
  [
    "Greenland",
    "GL",
    "299"
  ],
  [
    "Guatemala",
    "GT",
    "502"
  ],
  [
    "Guinea",
    "GN",
    "224"
  ],
  [
    "Guyana",
    "GY",
    "592"
  ],
  [
    "Haiti",
    "HT",
    "509"
  ],
  [
    "Honduras",
    "HN",
    "504"
  ],
  [
    "Hong Kong",
    "HK",
    "852",
    "香港"
  ],
  [
    "Hungary",
    "HU",
    "36"
  ],
  [
    "Iceland",
    "IS",
    "354"
  ],
  [
    "India",
    "IN",
    "91",
    "印度"
  ],
  [
    "Indonesia",
    "ID",
    "62",
    "印尼"
  ],
  [
    "Iran",
    "IR",
    "98"
  ],
  [
    "Iraq",
    "IQ",
    "964"
  ],
  [
    "Ireland",
    "IE",
    "353"
  ],
  [
    "Israel",
    "IL",
    "972"
  ],
  [
    "Italy",
    "IT",
    "39",
    "意大利"
  ],
  [
    "Ivory Coast",
    "CI",
    "225"
  ],
  [
    "Jamaica",
    "JM",
    "1876"
  ],
  [
    "Japan",
    "JP",
    "81",
    "日本"
  ],
  [
    "Jordan",
    "JO",
    "962"
  ],
  [
    "Kazakhstan",
    "KZ",
    "7"
  ],
  [
    "Kenya",
    "KE",
    "254"
  ],
  [
    "Kuwait",
    "KW",
    "965"
  ],
  [
    "Kyrgyzstan",
    "KG",
    "996"
  ],
  [
    "Laos",
    "LA",
    "856"
  ],
  [
    "Latvia",
    "LV",
    "371"
  ],
  [
    "Lebanon",
    "LB",
    "961"
  ],
  [
    "Lesotho",
    "LS",
    "266"
  ],
  [
    "Liberia",
    "LR",
    "231"
  ],
  [
    "Libya",
    "LY",
    "218"
  ],
  [
    "Liechtenstein",
    "LI",
    "423"
  ],
  [
    "Lithuania",
    "LT",
    "370"
  ],
  [
    "Luxembourg",
    "LU",
    "352"
  ],
  [
    "Macau",
    "MO",
    "853",
    "澳門"
  ],
  [
    "Madagascar",
    "MG",
    "261"
  ],
  [
    "Malawi",
    "MW",
    "265"
  ],
  [
    "Malaysia",
    "MY",
    "60",
    "馬來西亞"
  ],
  [
    "Maldives",
    "MV",
    "960"
  ],
  [
    "Mali",
    "ML",
    "223"
  ],
  [
    "Malta",
    "MT",
    "356"
  ],
  [
    "Mauritius",
    "MU",
    "230"
  ],
  [
    "Mexico",
    "MX",
    "52"
  ],
  [
    "Moldova",
    "MD",
    "373"
  ],
  [
    "Monaco",
    "MC",
    "377"
  ],
  [
    "Mongolia",
    "MN",
    "976"
  ],
  [
    "Montenegro",
    "ME",
    "382"
  ],
  [
    "Morocco",
    "MA",
    "212"
  ],
  [
    "Mozambique",
    "MZ",
    "258"
  ],
  [
    "Myanmar",
    "MM",
    "95"
  ],
  [
    "Namibia",
    "NA",
    "264"
  ],
  [
    "Nepal",
    "NP",
    "977",
    "尼泊爾"
  ],
  [
    "Netherlands",
    "NL",
    "31",
    "荷蘭"
  ],
  [
    "New Zealand",
    "NZ",
    "64",
    "紐西蘭"
  ],
  [
    "Nicaragua",
    "NI",
    "505"
  ],
  [
    "Niger",
    "NE",
    "227"
  ],
  [
    "Nigeria",
    "NG",
    "234"
  ],
  [
    "North Macedonia",
    "MK",
    "389"
  ],
  [
    "Norway",
    "NO",
    "47"
  ],
  [
    "Oman",
    "OM",
    "968"
  ],
  [
    "Pakistan",
    "PK",
    "92",
    "巴基斯坦"
  ],
  [
    "Palestine",
    "PS",
    "970"
  ],
  [
    "Panama",
    "PA",
    "507"
  ],
  [
    "Papua New Guinea",
    "PG",
    "675"
  ],
  [
    "Paraguay",
    "PY",
    "595"
  ],
  [
    "Peru",
    "PE",
    "51"
  ],
  [
    "Philippines",
    "PH",
    "63",
    "菲律賓"
  ],
  [
    "Poland",
    "PL",
    "48"
  ],
  [
    "Portugal",
    "PT",
    "351",
    "葡萄牙"
  ],
  [
    "Puerto Rico",
    "PR",
    "1787"
  ],
  [
    "Qatar",
    "QA",
    "974"
  ],
  [
    "Romania",
    "RO",
    "40"
  ],
  [
    "Russia",
    "RU",
    "7"
  ],
  [
    "Rwanda",
    "RW",
    "250"
  ],
  [
    "Samoa",
    "WS",
    "685"
  ],
  [
    "Saudi Arabia",
    "SA",
    "966"
  ],
  [
    "Senegal",
    "SN",
    "221"
  ],
  [
    "Serbia",
    "RS",
    "381"
  ],
  [
    "Seychelles",
    "SC",
    "248"
  ],
  [
    "Sierra Leone",
    "SL",
    "232"
  ],
  [
    "Singapore",
    "SG",
    "65",
    "新加坡"
  ],
  [
    "Slovakia",
    "SK",
    "421"
  ],
  [
    "Slovenia",
    "SI",
    "386"
  ],
  [
    "Somalia",
    "SO",
    "252"
  ],
  [
    "South Africa",
    "ZA",
    "27"
  ],
  [
    "South Korea",
    "KR",
    "82",
    "南韓"
  ],
  [
    "South Sudan",
    "SS",
    "211"
  ],
  [
    "Spain",
    "ES",
    "34",
    "西班牙"
  ],
  [
    "Sri Lanka",
    "LK",
    "94",
    "斯里蘭卡"
  ],
  [
    "Sudan",
    "SD",
    "249"
  ],
  [
    "Suriname",
    "SR",
    "597"
  ],
  [
    "Sweden",
    "SE",
    "46"
  ],
  [
    "Switzerland",
    "CH",
    "41"
  ],
  [
    "Syria",
    "SY",
    "963"
  ],
  [
    "Taiwan",
    "TW",
    "886",
    "台灣"
  ],
  [
    "Tajikistan",
    "TJ",
    "992"
  ],
  [
    "Tanzania",
    "TZ",
    "255"
  ],
  [
    "Thailand",
    "TH",
    "66",
    "泰國"
  ],
  [
    "Timor-Leste",
    "TL",
    "670"
  ],
  [
    "Togo",
    "TG",
    "228"
  ],
  [
    "Tonga",
    "TO",
    "676"
  ],
  [
    "Trinidad and Tobago",
    "TT",
    "1868"
  ],
  [
    "Tunisia",
    "TN",
    "216"
  ],
  [
    "Turkey",
    "TR",
    "90",
    "土耳其"
  ],
  [
    "Turkmenistan",
    "TM",
    "993"
  ],
  [
    "Uganda",
    "UG",
    "256"
  ],
  [
    "Ukraine",
    "UA",
    "380"
  ],
  [
    "United Arab Emirates",
    "AE",
    "971",
    "阿聯酋"
  ],
  [
    "United Kingdom",
    "GB",
    "44",
    "英國"
  ],
  [
    "United States",
    "US",
    "1",
    "美國"
  ],
  [
    "Uruguay",
    "UY",
    "598"
  ],
  [
    "Uzbekistan",
    "UZ",
    "998"
  ],
  [
    "Vanuatu",
    "VU",
    "678"
  ],
  [
    "Venezuela",
    "VE",
    "58"
  ],
  [
    "Vietnam",
    "VN",
    "84",
    "越南"
  ],
  [
    "Yemen",
    "YE",
    "967"
  ],
  [
    "Zambia",
    "ZM",
    "260"
  ],
  [
    "Zimbabwe",
    "ZW",
    "263"
  ]
];

/* ⚠️ HONG KONG IS THE LAUNCH MARKET, so the dial code starts there
 * rather than at whatever sorts first alphabetically. It is a starting
 * value, never a restriction — all 181 are in the dropdown. */
export const DEFAULT_DIAL = '852';
